import { render, staticRenderFns } from "./DialogNotificacao.vue?vue&type=template&id=6f31d587&scoped=true&lang=pug"
import script from "./DialogNotificacao.vue?vue&type=script&lang=js"
export * from "./DialogNotificacao.vue?vue&type=script&lang=js"
import style0 from "./DialogNotificacao.vue?vue&type=style&index=0&id=6f31d587&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f31d587",
  null
  
)

export default component.exports